// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".manual-check-container .cv-column{padding:0!important}.manual-check-container .bx--grid{margin-left:0!important;margin-right:0!important}", ""]);
// Exports
module.exports = exports;
